import { useEffect, useRef, type RefObject } from 'react';

/**
 * Where a box scrolls sideways past its edge, the edge fades: sets `data-fade` (l, r, lr) on the element for the
 * `.edge-fade` rules in stage.css. Returns the function to call from onScroll; it also follows the box's size.
 */
export function useEdgeFade(ref: RefObject<HTMLElement | null>, deps: unknown[] = []): () => void {
  const check = useRef(() => {});
  check.current = () => {
    const el = ref.current;
    if (!el) return;
    const l = el.scrollLeft > 2;
    const r = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    const fade = l && r ? 'lr' : l ? 'l' : r ? 'r' : '';
    if (fade) el.setAttribute('data-fade', fade);
    else el.removeAttribute('data-fade');
  };
  useEffect(() => {
    check.current();
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(() => check.current());
    ro.observe(el);
    // a table inside grows with its rows
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return () => check.current();
}
